import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

export const CardListItem = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: space-between;
  min-height: 96px;
  padding: 15px 24px 15px 9px;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  color: ${({ theme }) => theme.colors.font};

  ${maxMediaQueries.tablet`
    flex-wrap: wrap;
  `};

  ${maxMediaQueries.phablet`
    padding-left: 9px;
    padding-right: 9px;
  `};

  ${maxMediaQueries.phone`
    padding: 15px;
  `};

  > span:first-of-type {
    position: absolute;
    top: 15px;
    left: 9px;

    ${maxMediaQueries.phone`
      top: 15px;
      left: 15px;
    `};
  }

  small {
    display: ${({ adviser }) => (adviser ? 'inline-block' : 'block')};

    &:first-child {
      ${({ adviser }) => (adviser ? 'display: block' : null)};
    }
  }

  transition: background-color 0.15s esae;

  ${maxMediaQueries.phablet`
      padding-top: 21px;
      padding-bottom: 24px;

      img {
        top: 21px;
      }
  `};

  &:hover {
    background-color: #fff;
  }
`;

export const CardListItemLink = CardListItem.withComponent('a');
